"use client";

import { Box } from "@mui/material";
import type { ReactNode } from "react";

interface OnboardingShellProps {
  header: ReactNode;
  children: ReactNode;
}

export const OnboardingShell = ({ header, children }: OnboardingShellProps) => {
  return (
    <Box
      sx={(theme) => ({
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: theme.vars!.palette.rmh.paper["0-base"],
      })}
    >
      {header}
      <Box
        component="main"
        sx={{
          flex: 1,
          width: "100%",
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
